import { render, staticRenderFns } from "./language_ability.vue?vue&type=template&id=2ad2b642&"
import script from "./language_ability.vue?vue&type=script&lang=js&"
export * from "./language_ability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports